import {needAuth} from "../instance/Instance";

async function getAdminMenuList() {
    try{
        console.log(">>> api : 관리자 설정 목록 조회")
        return  await needAuth.get('/adminmenu');
    }catch (error){
        return error;
    }
}

export async function getAdminMenuViewList() {
    try{
        console.log(">>> api : 관리자 설정 목록 조회")
        return  await needAuth.get('/adminmenu/view');
    }catch (error){
        return error;
    }
}

async function updateAdminMenu(adminMenu) {
    const size = adminMenu.value;
    adminMenu = {id: adminMenu.id, globalsValue : adminMenu.value}
    if(adminMenu.id === 13){
        adminMenu = {...adminMenu, globalsValue : String(Number(size)*1024) }
    }
    try{
        console.log(">>> api : 관리자 설정 수정")
        return  await needAuth.put('/adminmenu', adminMenu);
    }catch (error){
        return error;
    }
}

async function testSMTP() {
    try{
        return  await needAuth.get('/adminmenu/testSMTP');
    }catch (error){
        return error;
    }
}

async function testAiConnect() {
    try{
        return  await needAuth.get('/adminmenu/testAI');
    }catch (error){
        return error;
    }
}

export {getAdminMenuList, updateAdminMenu, testSMTP, testAiConnect};